/* eslint-disable import/no-extraneous-dependencies */
import 'react-app-polyfill/stable';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@code/innovance-react-ui-kit';
import '@code/innovance-react-ui-kit/dist/assets/fonts.css';

import './front/index.css';
import App from './front/App';
import * as serviceWorker from './front/serviceWorker';
import ErrorBoundary from './front/ErrorBoundary';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
